import React from "react";
import { FaEnvelopeOpenText, FaInbox, FaPaperPlane } from "react-icons/fa";

function StatCard({ icon: Icon, label, value, variant = "sky" }) {
  const styles = {
    sky: "bg-sky-100 text-sky-700 dark:bg-sky-500/10 dark:text-sky-200",
    orange:
      "bg-orange-100 text-orange-700 dark:bg-orange-500/10 dark:text-orange-200",
    emerald:
      "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-200",
  };

  return (
    <div className="rounded-[1.5rem] border border-slate-200 bg-white p-4 shadow-sm dark:border-white/10 dark:bg-white/[0.05]">
      <div className="flex items-center gap-3">
        <div
          className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl ${
            styles[variant] || styles.sky
          }`}
        >
          <Icon />
        </div>

        <div>
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-slate-400">
            {label}
          </p>

          <p className="mt-1 font-titre text-2xl font-bold text-slate-950 dark:text-white">
            {value}
          </p>
        </div>
      </div>
    </div>
  );
}

function MessageStats({ receivedCount, unreadCount, sentCount }) {
  return (
    <div className="mb-6 grid gap-4 sm:grid-cols-3">
      <StatCard
        icon={FaInbox}
        label="Messages reçus"
        value={receivedCount}
        variant="sky"
      />

      <StatCard
        icon={FaEnvelopeOpenText}
        label="Non lus"
        value={unreadCount}
        variant="orange"
      />

      <StatCard
        icon={FaPaperPlane}
        label="Envoyés"
        value={sentCount}
        variant="emerald"
      />
    </div>
  );
}

export default MessageStats;